import { IsInt, IsNotEmpty, IsOptional, IsUUID, Min } from 'class-validator';
import { Type } from 'class-transformer';

import { FilterType } from '@vk-hr-tek/core/filter';

export class GetAttorneysUsersDto {
  @IsOptional()
  @IsInt()
  @Min(0)
  @Type(() => Number)
  offset = 0;

  @IsOptional()
  @IsInt()
  @Min(1)
  @Type(() => Number)
  // eslint-disable-next-line no-magic-numbers
  limit = 20;

  @IsNotEmpty()
  @IsUUID()
  company_id: string;

  filters: FilterType;
}
